import { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function SludgeDewatering() {
  useEffect(() => {
    document.title = 'Sludge Dewatering Equipment Supplier in China | Yixing'
  }, [])

  return (
    <div className="page">
      <section className="page-header">
        <p className="eyebrow">DEFINED SLUDGE DEWATERING PACKAGES</p>
        <h1>Sludge Dewatering Equipment Supply from Yixing</h1>
        <p>Project-specific sludge dewatering equipment coordinated through selected specialist manufacturing partners in Yixing, China.</p>
      </section>

      <section className="page-content">
        <h2>Equipment Scope</h2>
        <p>The selection depends on sludge characteristics, feed variability, the target cake solids or moisture content, the operating pattern and local maintenance resources. Share actual process data first; the appropriate equipment option can then be reviewed with the specialist manufacturing partner.</p>

        <h2>Start with Your Project Requirements</h2>
        <p>Share the scope before scheduling the technical step. For an initial written review, share the application, capacity or airflow, key contaminants, required equipment scope, preferred materials, available drawings, destination and target schedule.</p>
        <Link to="/contact" className="btn-primary">Send Requirements by Email ↗</Link>
      </section>
    </div>
  )
}
